import { render, staticRenderFns } from "./student_request_edit.vue?vue&type=template&id=4e330b9d&scoped=true&"
import script from "./student_request_edit.vue?vue&type=script&lang=js&"
export * from "./student_request_edit.vue?vue&type=script&lang=js&"
import style0 from "./student_request_edit.vue?vue&type=style&index=0&id=4e330b9d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e330b9d",
  null
  
)

export default component.exports